import React from 'react';
/* eslint-disable venom/no-internal-modules */
import { pageDefinition } from 'site-modules/shared/pages/page';
import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { CmsModel } from 'client/data/models/cms';
import { EdmundsEmptyDecorator } from 'site-modules/shared/pages/decorators/edmunds-empty';
import { FAST_CHARGING_LEADERBOARD_CONTENT_PATH } from 'site-modules/editorial/constants/fast-charging-leaderboard';
import { FastChargingLeaderboard } from 'site-modules/editorial/components/fast-charging-leaderboard/fast-charging-leaderboard';

export const pageOptions = {
  name: 'fast_charging_leaderboard',
  category: 'widgets',
  seo: {
    title: 'Fast Charging Leaderboard',
    robots: {
      noIndex: true,
      noFollow: true,
    },
  },
  preload: store => {
    const preloader = new ModelPreloader(store);
    preloader.resolve(`content["${FAST_CHARGING_LEADERBOARD_CONTENT_PATH}"]`, CmsModel);
    return preloader.load();
  },
  decorator: EdmundsEmptyDecorator,
  component: () => <FastChargingLeaderboard isWidget />,
};

export default pageDefinition(pageOptions);
